<template>
  <v-sheet
   color="white"
             elevation="5"
             rounded
             class="mt-5 mb-5 pt-3 pb-5 pl-3 pr-3"
  >
    <div class="profile-content">
        <v-tabs v-model="tab">
            <v-tab key="certPrograms">
                Certificate Programs
            </v-tab>
            <v-tab key="showTypes">
                Show types
            </v-tab>
            <v-tab key="titles">
                Title types
            </v-tab>
            <v-tab key="divisions">
                Divisions
            </v-tab>
            <v-tab key="dnaStatuses">
                DNA statuses
            </v-tab>
            <v-tab key="breeds">
                Breeds
            </v-tab>
            <v-tab key="bodyColors">
                Body colors
            </v-tab>
            <v-tab key="trimColors">
                Trim Colors
            </v-tab>
            <v-tab key="eyeColors">
                Eye colors
            </v-tab>
            <v-tab key="ps">
                Point Schedules
            </v-tab>

        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item key="certPrograms">
                <CertProgramMaintenance />
            </v-tab-item>
            <v-tab-item key="showTypes">
                <ShowTypesMaintenance />
            </v-tab-item>
            <v-tab-item key="titles">
                <CategoryManagement />
            </v-tab-item>
            <v-tab-item key="divisions">
                <DivisionsMaintenance />
            </v-tab-item>
            <v-tab-item key="dnaStatuses">
                <DNAStatusMaintenance />
            </v-tab-item>
            <v-tab-item key="breeds">
                <BasicLUMaintenance luType="Breeds" maxSize="3" />
            </v-tab-item>
            <v-tab-item key="bodyColors">
                <BasicLUMaintenance luType="Body" maxSize="2" />
            </v-tab-item>
            <v-tab-item key="trimColors">
                <BasicLUMaintenance luType="Trim" maxSize="2" />
            </v-tab-item>
            <v-tab-item key="eyeColors">
                <BasicLUMaintenance luType="Eyes" maxSize="3" />
            </v-tab-item>
            <v-tab-item key="ps">
                <PointSchedulesMaintenance />
            </v-tab-item>
        </v-tabs-items>
    </div>
  </v-sheet>
</template>

<script lang="ts">
import Vue from "vue";
import CategoryManagement from "@/components/Admin/CategoryManagement.vue";
import CertProgramMaintenance from "@/components/Admin/Lookups/CertProgramMaintenance.vue";
import ShowTypesMaintenance from "@/components/Admin/Lookups/ShowTypesMaintenance.vue";
import DivisionsMaintenance from "@/components/Admin/Lookups/DivisionsMaintenance.vue";
import DNAStatusMaintenance from "@/components/Admin/Lookups/DNAStatusMaintenance.vue";
import BasicLUMaintenance from "@/components/Admin/Lookups/BasicLUMaintenance.vue";
import PointSchedulesMaintenance from "@/components/Admin/Lookups/PointSchedulesMaintenance.vue";

export default Vue.extend({
  name: "LookupsMaintenance",
  components: {
      CategoryManagement,
      DivisionsMaintenance,
      BasicLUMaintenance,
      DNAStatusMaintenance,
      PointSchedulesMaintenance,
      CertProgramMaintenance,
      ShowTypesMaintenance,
},
  data: function() {
    return {
      tab: null,
    };
  },
  methods: {
  }
});
</script>
